import { Button } from '@eb/eds-button';
import { withMainControls } from '@eb/eds-structure';
import { gettext } from '@eb/i18n';
import React from 'react';

interface ShowMoreEventsProps {
    isLoading: boolean;
    onClick: Function;
    hasMore: boolean;
}

interface MainControlsProps {
    addMainNotification: Function;
}

export const ShowMoreEventsInternal: React.FunctionComponent<
    ShowMoreEventsProps & MainControlsProps
> = (props) => {
    if (!props.hasMore) {
        return null;
    }

    return (
        <div className="eds-l-pad-top-4 eds-align--center">
            <Button isLoading={props.isLoading} onClick={() => props.onClick()}>
                {gettext('Show more')}
            </Button>
        </div>
    );
};

export const ShowMoreEvents = withMainControls(ShowMoreEventsInternal);
